import { AutogenModelMulticompanyCompany, AutogenRowMulticompanyCompany } from "./autogen/AutogenModelMulticompanyCompany";

export class ModelMulticompanyCompany extends AutogenModelMulticompanyCompany<RowMulticompanyCompany> {
	constructor() {
		super(RowMulticompanyCompany);
	}
}

export class RowMulticompanyCompany extends AutogenRowMulticompanyCompany {
}